import { useEffect } from 'react';
import { NextRouter, useRouter } from 'next/router';

import { UiButton, UiIcon, UiText, UiTitle } from '@frontend/znanie-uikit';

import css from './SuccessNotification.module.scss';

export const BecomeSpeakerSuccessNotification = () => {
  const router: NextRouter = useRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={css.successNotificationContainer}>
      <UiIcon name="success" />

      <UiTitle className={css.title}>Ваша заявка отправлена</UiTitle>

      <UiText
        align="center"
        size="small"
        color="grey"
        className={css.boundedText}
      >
        {`Ваша заявка будет рассмотрена в течение 3-х дней.
        Результат будет направлен на\u00A0электронный адрес, а\u00A0также будет отображаться в\u00A0вашем Личном кабинете.`}
      </UiText>

      <UiButton
        variant="outline"
        onClick={() => router.push('/profile/main')}
        className={css.button}
      >
        Перейти в личный кабинет
      </UiButton>
    </div>
  );
};
